export const TEST_ID = 'returnToServiceFooter';

export const CANCEL_BUTTON_TEST_ID = 'returnToServiceFooterCancelButton';

export const KEEP_BUTTON_TEST_ID = 'returnToServiceFooterKeepButton';

export const RETURN_BUTTON_TEST_ID = 'returnToServiceFooterReturnButton';
